import { getSortedLinks, Links } from "model/Links";
import { IconLink } from "./IconLink";
import { LinksContainer } from "./styles";

interface Props {
  links: Links;
}

export const LinkBar = ({ links }: Props) => {
  const sortedLinks = getSortedLinks(links);
  return (
    <LinksContainer>
      {sortedLinks.map((l) => (
        <IconLink key={l.url} link={l} />
      ))}
    </LinksContainer>
  );
};
